function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1051",
  "data-name": "Path 1051",
  d: "M25.034,22H4.352A3.264,3.264,0,0,0,1,25.16V36.746a3.264,3.264,0,0,0,3.352,3.16h.67v3.663A1.6,1.6,0,0,0,6,45.039a1.656,1.656,0,0,0,.651.134,1.634,1.634,0,0,0,1.131-.454l5.034-4.813H25.034a3.264,3.264,0,0,0,3.352-3.16V25.16A3.264,3.264,0,0,0,25.034,22Z",
  transform: "translate(-1 -3.041)",
  fill: "#ffbc5a"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1052",
  "data-name": "Path 1052",
  d: "M24.608,22H9v4.74a4.266,4.266,0,0,0,4.309,4.213h14.65V25.16A3.264,3.264,0,0,0,24.608,22Z",
  transform: "translate(-0.574 -3.041)",
  fill: "#ef9d3a"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1053",
  "data-name": "Path 1053",
  d: "M44.61,4h-29.3A4.266,4.266,0,0,0,11,8.213V25.593a4.266,4.266,0,0,0,4.309,4.213H32.775l7.255,7.344a1.866,1.866,0,0,0,3.191-1.323V29.806H44.61a4.266,4.266,0,0,0,4.309-4.213V8.213A4.266,4.266,0,0,0,44.61,4Z",
  transform: "translate(-0.467 -4)",
  fill: "#fff"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_1054",
  "data-name": "Path 1054",
  d: "M43.016,4H40.909a4.266,4.266,0,0,1,4.309,4.213V25.593a4.266,4.266,0,0,1-4.309,4.213l.718.413v-.413h1.388a4.266,4.266,0,0,0,4.309-4.213V8.213A4.266,4.266,0,0,0,43.016,4Z",
  transform: "translate(1.127 -4)",
  fill: "#e6e6e6"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "Group_59",
  "data-name": "Group 59",
  transform: "translate(21.066 6.32)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1055",
  "data-name": "Path 1055",
  d: "M30.48,12.107H22.053a1.053,1.053,0,1,1,0-2.107H30.48a1.053,1.053,0,1,1,0,2.107Z",
  transform: "translate(-21 -10)",
  fill: "#505572"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  id: "Group_60",
  "data-name": "Group 60",
  transform: "translate(21.066 16.853)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1056",
  "data-name": "Path 1056",
  d: "M34.693,22.107H22.053a1.053,1.053,0,1,1,0-2.107h12.64a1.053,1.053,0,0,1,0,2.107Z",
  transform: "translate(-21 -20)",
  fill: "#505572"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  id: "Group_61",
  "data-name": "Group 61",
  transform: "translate(21.066 11.586)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1057",
  "data-name": "Path 1057",
  d: "M38.906,17.107H22.053a1.053,1.053,0,1,1,0-2.107H38.906a1.053,1.053,0,1,1,0,2.107Z",
  transform: "translate(-21 -15)",
  fill: "#505572"
}));

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Get_help_icon",
    "data-name": "Get help icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.452,
    height: 42.132,
    viewBox: "0 0 48.452 42.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help_icon.4404054e.svg";
export { ForwardRef as ReactComponent };